import React from "react";
import "./styles.css";

const statusMessages = {
  LOADING_ROOM: "We are preparing your session",
  LOADING_SCENE: "Loading 3D scene",
};

const Loading = ({ status }) => {
  const isLoadingScene = status === "LOADING_SCENE";
  return (
    <div className={`loading-container column ${isLoadingScene ? "transparent" : ""}`}>
      <div className="loader">
        <div className={`lds-default ${isLoadingScene ? "transparent" : ""}`}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <p className="logo-title">{statusMessages[status] || "Loading"}</p>
    </div>
  );
};
export default Loading;
